import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "wrap-accordion-default" }
const _hoisted_2 = {
  key: 1,
  class: "font-semibold text-xl"
}
const _hoisted_3 = { class: "content" }

import {
  ref,
  withDefaults,
  toRefs,
  useSlots
} from 'vue'

type TAccordionDefaultProps = {
  isShowIcon?: boolean,
  title?: string,
  active?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Default',
  props: {
    isShowIcon: { type: Boolean, default: true },
    title: { default: 'Title' },
    active: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { isShowIcon: boolean, title: string, active: boolean }



const {
  isShowIcon,
  title,
  active
} = toRefs(props)

const slot = useSlots()

const isOpen = ref(active.value)

const toggleAccordion = () => {
  isOpen.value = !isOpen.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleAccordion())),
      class: "header"
    }, [
      (_unref(slot)['header'])
        ? _renderSlot(_ctx.$slots, "header", {
            key: 0,
            isOpen: isOpen.value
          })
        : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(title)), 1)),
      (_unref(isShowIcon))
        ? (_openBlock(), _createElementBlock("i", {
            key: 2,
            class: "pi pi-chevron-right text-sm transition-all duration-200",
            style: _normalizeStyle({ transform: isOpen.value ? 'rotate(90deg)' : 'rotate(0)', color: '#252F40' })
          }, null, 4))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "content")
    ], 512), [
      [_vShow, isOpen.value]
    ])
  ]))
}
}

})